import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center py-10" }

import type { HTMLAttributes } from 'vue'
import { reactiveOmit } from '@vueuse/core'
import { cn } from '@/lib/utils'
import TableCell from './TableCell.vue'
import TableRow from './TableRow.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'TableEmpty',
  props: {
    class: {},
    colspan: { default: 1 }
  },
  setup(__props: any) {

const props = __props

const delegatedProps = reactiveOmit(props, 'class')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TableRow, null, {
    default: _withCtx(() => [
      _createVNode(TableCell, _mergeProps({
        class: 
        _unref(cn)(
          'p-4 whitespace-nowrap align-middle text-sm text-foreground',
          props.class,
        )
      
      }, _unref(delegatedProps)), {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ]),
        _: 3
      }, 16, ["class"])
    ]),
    _: 3
  }))
}
}

})